"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DatePicker_meta_1 = require("../../DatePicker.meta");
var InjectedStyledComponent_1 = require("../../../../../shared/InjectedStyledComponent");
var rawCssPrefix = "\nposition: relative;\nwidth: 100%;\n";
exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY, ['inputWrapper'], rawCssPrefix);
